import { Controller } from '@hotwired/stimulus'
import EventPublisher from '../utilities/event_publisher'

/* The move form inside the side panel. While it is open the layout canvas is the
   picker: the scrim steps aside, the free positions light up, and clicking one
   fills the New position select. Changing the days refetches the form so the
   list (and the lit positions) match. */
export default class extends Controller {
  static targets = ['target']
  static values = { url: String, targets: Array, fromUnit: Number }

  // The scrim is remembered on connect: by disconnect the form is already out of the DOM
  connect() {
    this.scrim = this.panelElement
    window.addEventListener('booking-move:pick', this.pick)
    this.scrim?.classList.add('beachy-side-panel-passive')
    EventPublisher.publish('booking-move:targets', {
      unitIds: this.targetsValue, fromUnitId: this.fromUnitValue, chosenUnitId: this.chosenUnitId
    })
  }

  disconnect() {
    window.removeEventListener('booking-move:pick', this.pick)
    this.scrim?.classList.remove('beachy-side-panel-passive')
    EventPublisher.publish('booking-move:end')
  }

  refresh() {
    const panel = this.panel
    if (!panel) return

    const params = new URLSearchParams(new FormData(this.element))
    params.delete('authenticity_token')
    const separator = this.urlValue.includes('?') ? '&' : '?'
    panel.fetchInto(`${this.urlValue}${separator}${params}`)
  }

  pick = event => {
    if (!this.hasTargetTarget) return

    this.targetTarget.value = event.detail.inventoryUnitId
    this.targetTarget.focus()
    this.choose()
  }

  // The select is the one source of the choice, whether it was clicked on the map or picked here
  choose() {
    EventPublisher.publish('booking-move:choice', { inventoryUnitId: this.chosenUnitId })
  }

  get chosenUnitId() {
    if (!this.hasTargetTarget || !this.targetTarget.value) return null

    return Number(this.targetTarget.value)
  }

  get panelElement() {
    return this.element.closest('[data-controller~="beachy-side-panel"]')
  }

  get panel() {
    const element = this.panelElement
    if (!element) return null

    return this.application.getControllerForElementAndIdentifier(element, 'beachy-side-panel')
  }
}
